import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    isSuccess: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_REQUEST:
      return {
        ...state,
        isSuccess: false,
        isProgress: true,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_SUCCESS:
      return {
        data: action.response,
        isSuccess: action.response.success,
        isProgress: false,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_FAILURE:
      return {
        data: null,
        error: action.error,
        isSuccess: false,
        isProgress: false,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_RESET:
      return {
        ...state,
        isSuccess: false,
        isProgress: false,
      };
    default:
      return state;
  }
}
